<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import useMatestoreStore from '@/store/matestoreStore';
import { useMicroMessageStore } from '@/store/messageStore';
import { noticeMicro } from '@/utils/messageHandler';
const props = withDefaults(
  defineProps<{
    theme: string;
  }>(),
  {
    theme: 'v1',
  }
);
const messageStore = useMicroMessageStore();
const microStore = useMatestoreStore();
const totalUnread = computed(
  () => messageStore.microMessageMapping['im/notice']?.noticeBadgeNum || ''
);

function switchPopover(open: boolean) {
  noticeMicro('im/notice', { action: 'switchPopover', open });
}

onMounted(() => {
  const el = document.getElementById('notice-popcontent');

  if (el && microStore.hasNotice) {
    microStore.activateMicroApp('im/notice', el as any, true);
  }
});
</script>

<template>
  <n-popover
    popper-class="notice-popover-popper"
    :placement="theme === 'v1' ? 'bottom-end' : 'right-start'"
    :popper-style="{ width: 368, height: 667, padding: 0 }"
    trigger="click-remain"
    :destroy-on-hide="false"
    @show="switchPopover(true)"
    @hide="switchPopover(false)"
  >
    <template #reference>
      <div class="notice-icon-wrap">
        <n-button
          v-tit-tracker:click="{
            button_group: '通知',
            button_name: '通知',
            trackName: 'FrameClick',
            requirement_id: 754,
            track_sign: 'aplatform.b2862.c2866.click.FrameClick',
          }"
          v-tooltip.bottom="{ content: '通知', distance: 20 }"
          class="mate-btn-reverse-icon"
          type="text"
          icon="notice"
        />

        <div class="new-notice-badge" v-if="totalUnread">
          <span>{{ totalUnread }}</span>
        </div>
      </div>
    </template>
    <template #popper>
      <n-pop-content class="notice-popcontent">
        <div id="notice-popcontent"></div>
      </n-pop-content>
    </template>
  </n-popover>
</template>

<style scoped lang="scss">
.notice-popcontent {
  padding: 0px;
}
.notice-icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
  }

  .n-icon {
    color: var(--tit-header-label-color);
  }

  .new-notice-badge {
    position: absolute;
    right: -6px;
    top: 0;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    border: 1px solid white;
    background-color: var(--n-text-error-default);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;

    > span {
      font-size: 12px;
      transform-origin: center center;
      transform: scale(0.8);
      white-space: nowrap;
    }
  }
}
</style>
